const DEFAULT_PER_PAGE = 10;
const DEFAULT_PAGE = 1;

export { DEFAULT_PER_PAGE, DEFAULT_PAGE };
